<template>
    <b-container class="pl-0 pr-0 mb-5">
        <b-col lg="12" class="no-gutters">
            <b-row v-if="!loading && (!organizations || organizations.length < 1)">
                <span class="col-12 no-results pt-1 pb-3">
                        {{ $t('organization.no_organizations') }}
                </span>
            </b-row>
            <b-row>
                <!-- Organizations -->
                <b-col v-for="organization in organizations" v-bind:key="organization.id" xl="4" lg="6" md="6"
                       class="mb-4" @click.stop="showCampaigns(organization)">
                    <category-organizations-feed-item
                            :organization="organization"/>
                </b-col>
            </b-row>
        </b-col>
    </b-container>
</template>

<script>
    import CategoryOrganizationsFeedItem from "@/components/feed/CategoryOrganizationsFeedItem";
    export default {
        name: "category-organizations-feed",
        components: {CategoryOrganizationsFeedItem},
        data() {
            return {
                CHARITY: 1,
                ENV: 2,
                SCHOOLS: 3,
                SPORTS: 4,
                selected: -1,
                results: null,
                nearTeam: [],
                loading: false
            }
        },
        props: {
            organizations: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        methods: {
            showCampaigns(organization) {
                this.$router.push({name: 'organization-campaigns-view', params: {id: organization.id}})
            },
        }
    }
</script>

<style scoped>
</style>
